<template>
  <v-card v-if="haveDataToShow" :class="[margin]">
    <v-card-text>
      <h2 class="title mt-0 mb-3">{{ $t('candidate-profile-finance-label', language) }}</h2>
      <ui-content class="sectionRow" v-if="profile.tuitionFeesAbleToPay !== null">
        <h3 class="subheading">{{ $t('candidate-profile-tuition-fees-able-pay', language) }}</h3>
        <span>{{ profileTuitionFeesAbleToPay(profile.tuitionFeesAbleToPay) }}</span>
      </ui-content>

      <v-divider class="my-3" v-if="profile.studyExpensesPayer !== null" />
      <ui-content class="sectionRow" v-if="profile.studyExpensesPayer !== null">
        <h3 class="subheading">{{ $t('candidate-profile-study-expenses-payer-label', language) }}</h3>
        <span>{{ studyExpensesPayer }}</span>
      </ui-content>
      <ui-content
        v-if="
          studyExpensesPayerIsOther &&
            translation &&
            translation.studyExpensesPayerOtherSpecification !== null &&
            translation.studyExpensesPayerOtherSpecification !== ''
        "
        class="sectionRow"
      >
        <div></div>
        <!-- Hack to put specification to the right -->
        <p v-html="$htmlEnter(translation.studyExpensesPayerOtherSpecification)" class="specification" />
      </ui-content>
      <v-divider class="my-3" v-if="profile.hasFirstStudyYearLivingExpensesFinancialResources !== null" />
      <ui-content class="sectionRow" v-if="profile.hasFirstStudyYearLivingExpensesFinancialResources !== null">
        <h3 class="subheading question">
          {{ $t('candidate-profile-has-first-study-year-living-expenses-financial-resources-label', language) }}
        </h3>
        <span>{{ getYesNoLabel(profile.hasFirstStudyYearLivingExpensesFinancialResources) }}</span>
      </ui-content>

      <v-divider class="my-3" v-if="profile.livingExpensesPayer !== null" />
      <ui-content class="sectionRow" v-if="profile.livingExpensesPayer !== null">
        <h3 class="subheading">{{ $t('candidate-profile-living-expenses-payer-label', language) }}</h3>
        <span>{{ livingExpensesPayer }}</span>
      </ui-content>
      <ui-content
        v-if="
          livingExpensesPayerIsOther &&
            translation &&
            translation.livingExpensesPayerOtherSpecification !== null &&
            translation.livingExpensesPayerOtherSpecification !== ''
        "
        class="sectionRow"
      >
        <div></div>
        <!-- Hack to put specification to the right because I'm pas bon en css. -->
        <p v-html="$htmlEnter(translation.livingExpensesPayerOtherSpecification)" class="specification" />
      </ui-content>

      <v-divider class="my-3" v-if="profile.willComeToCanadaWithFamilyMember !== null" />
      <ui-content class="sectionRow" v-if="profile.willComeToCanadaWithFamilyMember !== null">
        <h3 class="subheading question">{{ $t('candidate-profile-comes-to-canada-with-family-member-label', language) }}</h3>
        <span>{{ getYesNoLabel(profile.willComeToCanadaWithFamilyMember) }}</span>
      </ui-content>
      <ui-content
        v-if="
          profile.willComeToCanadaWithFamilyMember &&
            translation &&
            translation.willComeToCanadaWithFamilyMemberSpecification !== null &&
            translation.willComeToCanadaWithFamilyMemberSpecification !== ''
        "
        class="sectionRow"
      >
        <div></div>
        <!-- Hack to put specification to the right because I'm pas bon en css. -->
        <p v-html="$htmlEnter(translation.willComeToCanadaWithFamilyMemberSpecification)" class="specification" />
      </ui-content>

      <v-divider class="my-3" v-if="hasFinancialResourcesProofs" />
      <ui-content class="sectionRow" v-if="hasFinancialResourcesProofs">
        <h3 class="subheading question">{{ $t('candidate-profile-financial-resources-proofs-label', language) }}</h3>
        <span>{{ financialResourcesProofsYesNoLabel }}</span>
      </ui-content>
      <div v-if="hasFinancialResourcesProofs">
        <ui-content v-for="proof in financialResourcesProofs" :key="proof">
          <!-- Hack to put specification to the right because I'm pas bon en css. -->
          <p v-html="$htmlEnter(proof)" class="specification" />
        </ui-content>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { Consts } from '@/helpers/consts'
import { TuitionFeesAbleToPayMixin } from '@/mixins/tuition-fees-able-to-pay'

export default {
  data() {
    return {
      language: 'fr' // Always french for now
    }
  },
  props: {
    profile: {
      type: Object,
      required: true
    },
    margin: {
      type: String,
      required: true
    }
  },
  mixins: [TuitionFeesAbleToPayMixin],
  computed: {
    haveDataToShow: function() {
      return (
        this.isNotFromFrance &&
        (this.profile.tuitionFeesAbleToPay ||
          this.profile.studyExpensesPayer ||
          (this.studyExpensesPayerIsOther &&
            this.translation &&
            this.translation.studyExpensesPayerOtherSpecification !== null &&
            this.translation.studyExpensesPayerOtherSpecification !== '') ||
          this.profile.hasFirstStudyYearLivingExpensesFinancialResources !== null ||
          this.profile.livingExpensesPayer !== null ||
          (this.livingExpensesPayerIsOther &&
            this.translation &&
            this.translation.livingExpensesPayerOtherSpecification !== null &&
            this.translation.livingExpensesPayerOtherSpecification !== '') ||
          this.profile.willComeToCanadaWithFamilyMember !== null ||
          (this.profile.willComeToCanadaWithFamilyMember &&
            this.translation &&
            this.translation.willComeToCanadaWithFamilyMemberSpecification !== null &&
            this.translation.willComeToCanadaWithFamilyMemberSpecification !== '') ||
          this.hasFinancialResourcesProofs)
      )
    },
    isNotFromFrance: function() {
      return this.profile.nationalities.filter(x => x.countryCode === Consts.FRANCE_COUNTRY_CODE).length === 0
    },
    translation: function() {
      return this.profile.translations.find(t => t.language === Consts.CONTENT_LANGUAGE_FR)
    },
    livingExpensesPayer: function() {
      if (this.profile.livingExpensesPayer === Consts.LIVING_EXPENSES_PAYER_ME) {
        return this.$t('living-expenses-payer-me', this.language)
      } else if (this.profile.livingExpensesPayer === Consts.LIVING_EXPENSES_PAYER_FAMILY_MEMBER) {
        return this.$t('living-expenses-payer-family-member', this.language)
      } else if (this.profile.livingExpensesPayer === Consts.LIVING_EXPENSES_PAYER_ME_AND_FAMILY_MEMBER) {
        return this.$t('living-expenses-payer-me-and-family-member', this.language)
      } else if (this.profile.livingExpensesPayer === Consts.LIVING_EXPENSES_SCHOLARSHIP) {
        return this.$t('living-expenses-scholarship', this.language)
      } else if (this.profile.livingExpensesPayer === Consts.LIVING_EXPENSES_PAYER_OTHER) {
        return this.$t('living-expenses-payer-other', this.language)
      } else {
        return ''
      }
    },
    studyExpensesPayer: function() {
      if (this.profile.studyExpensesPayer === Consts.STUDY_EXPENSES_PAYER_ME) {
        return this.$t('living-expenses-payer-me', this.language)
      } else if (this.profile.studyExpensesPayer === Consts.STUDY_EXPENSES_PAYER_FAMILY_MEMBER) {
        return this.$t('living-expenses-payer-family-member', this.language)
      } else if (this.profile.studyExpensesPayer === Consts.STUDY_EXPENSES_PAYER_ME_AND_FAMILY_MEMBER) {
        return this.$t('living-expenses-payer-me-and-family-member', this.language)
      } else if (this.profile.studyExpensesPayer === Consts.STUDY_EXPENSES_SCHOLARSHIP) {
        return this.$t('living-expenses-scholarship', this.language)
      } else if (this.profile.studyExpensesPayer === Consts.STUDY_EXPENSES_PAYER_OTHER) {
        return this.$t('living-expenses-payer-other', this.language)
      } else {
        return ''
      }
    },
    livingExpensesPayerIsOther: function() {
      return this.profile.livingExpensesPayer === Consts.LIVING_EXPENSES_PAYER_OTHER
    },
    studyExpensesPayerIsOther: function() {
      return this.profile.studyExpensesPayer === Consts.STUDY_EXPENSES_PAYER_OTHER
    },
    hasFinancialResourcesProofs: function() {
      return this.profile.financialResourcesProofs.length > 0
    },
    financialResourcesProofsYesNoLabel: function() {
      return this.profile.financialResourcesProofs[0] === Consts.FINANCIAL_RESOURCE_PROOF_NONE
        ? this.$t('no-option', this.language)
        : this.$t('yes-option', this.language)
    },
    financialResourcesProofs: function() {
      const proofs = []

      this.profile.financialResourcesProofs.forEach(proof => {
        switch (proof) {
          case Consts.FINANCIAL_RESOURCE_PROOF_BANK_TRANSACTION:
            proofs.push('- ' + this.$t('financial-resource-proof-bank-transaction', this.language))
            break
          case Consts.FINANCIAL_RESOURCE_PROOF_COUNTRY_CONTROL_OFFICE_FUNDS:
            proofs.push('- ' + this.$t('financial-resource-proof-country-control-office-funds', this.language))
            break
          case Consts.FINANCIAL_RESOURCE_PROOF_SALARY_STATEMENT:
            proofs.push('- ' + this.$t('financial-resource-proof-salary-statement', this.language))
            break
          case Consts.FINANCIAL_RESOURCE_PROOF_TAX_STATEMENT:
            proofs.push('- ' + this.$t('financial-resource-proof-tax-statement', this.language))
            break
          case Consts.FINANCIAL_RESOURCE_PROOF_BANK_FUNDS:
            proofs.push('- ' + this.$t('financial-resource-proof-bank-funds', this.language))
            break
          case Consts.FINANCIAL_RESOURCE_PROOF_BANK_LETTER:
            proofs.push('- ' + this.$t('financial-resource-proof-bank-letter', this.language))
            break
          case Consts.FINANCIAL_RESOURCE_PROOF_MORTGAGE:
            proofs.push('- ' + this.$t('financial-resource-proof-mortage', this.language))
            break
        }
      })

      return proofs
    }
  },
  methods: {
    getYesNoLabel: function(value) {
      return value ? this.$t('yes-option', this.language) : this.$t('no-option', this.language)
    }
  }
}
</script>

<style lang="stylus">
.question {
  width: 77%;
}

.sectionRow {
  display: flex;
  justify-content: space-between;
}

.specification {
  font-style: italic;
}
</style>
